import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";

const classNames =
{
    checkbox: "checkbox",
    uiDisabled: "ui-disabled",
    selectAllCheckBoxControl: "SelectAllCheckBoxControl"
} as const;

const events =
{
    init
};

registerEvents("checkbox", events);

function init(selector: JQueryInput)
{
    const checkbox = $(selector);

    checkbox.filter("[indeterminate]").prop("indeterminate", true);

    checkbox.on("click keydown", function (this, event)
    {
        // If the checkbox is disabled, prevent all interaction EXCEPT for tabbing (and the select all checkbox on checkbox browses).
        if (this.classList.contains(classNames.uiDisabled) && event.key !== "Tab" && !this.classList.contains(classNames.selectAllCheckBoxControl))
        {
            event.preventDefault();
        }
    });
}
